// extracted by mini-css-extract-plugin
export default {"header":"Header_header__I8H9x","MuiSvgIcon-root":"Header_MuiSvgIcon-root__tPLnb"};